// Cart state for the TransferDialog: keeps add/remove/inc/dec separate
// from the dialog component so its complexity stays low.
import { useCallback, useMemo, useState } from "react";

export function useTransferCart() {
  const [cart, setCart] = useState({});

  const inc = useCallback((pid) => {
    setCart((c) => ({ ...c, [pid]: (c[pid] || 0) + 1 }));
  }, []);

  const dec = useCallback((pid) => {
    setCart((c) => {
      const cur = c[pid] || 0;
      if (cur <= 1) {
        // eslint-disable-next-line no-unused-vars
        const { [pid]: _drop, ...rest } = c;
        return rest;
      }
      return { ...c, [pid]: cur - 1 };
    });
  }, []);

  const remove = useCallback((pid) => {
    setCart((c) => {
      // eslint-disable-next-line no-unused-vars
      const { [pid]: _drop, ...rest } = c;
      return rest;
    });
  }, []);

  const reset = useCallback(() => setCart({}), []);

  // Build a list of {productId, qty} from the cart. The caller resolves the
  // actual product record so this hook stays decoupled from the catalog.
  const entries = useMemo(() => Object.entries(cart).map(([pid, qty]) => ({ pid, qty })), [cart]);
  const totalQty = useMemo(() => entries.reduce((s, e) => s + e.qty, 0), [entries]);

  return { cart, entries, totalQty, inc, dec, remove, reset };
}
